export const MediaFileType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PDF: 'PDF',
  DOCX: 'DOCX',
  EXCEL: 'EXCEL',
  CSV: 'CSV',
  TEXT: 'TEXT',
  UNSUPPORTED: 'UNSUPPORTED',
};
